import { newViewActions } from "@/store/newView/newView.slice";

import { aventureApi } from "./apiService/aventureApi";
import { axiosService } from "./apiService/axiosService";
import { loadingError } from "./error.service";

export const newListApi = aventureApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllViews: builder.query({
      queryFn: async (_, { dispatch }) => {
        try {
          const { data } = await axiosService.get("app/view/all");
          dispatch(newViewActions.setAllViews(data?.data));

          return { data };
        } catch (error) {
          dispatch(
            loadingError(
              error.response?.data?.message || error?.message || error
            )
          );
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      providesTags: ["newViews"],
    }),

    addView: builder.mutation({
      queryFn: async (options, { dispatch }) => {
        try {
          const { data } = await axiosService.post("app/view", options);
          return { data };
        } catch (error) {
          dispatch(
            loadingError(
              error.response?.data?.message || error?.message || error
            )
          );
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      invalidatesTags: ["newViews"],
    }),

    updateNewView: builder.mutation({
      queryFn: async (options, { dispatch }) => {
        try {
          const { data } = await axiosService.patch(
            `app/view/${options?.id}`,
            options?.params
          );
          return { data };
        } catch (error) {
          dispatch(
            loadingError(
              error.response?.data?.message || error?.message || error
            )
          );
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      invalidatesTags: ["newViews"],
    }),

    deleteNewView: builder.mutation({
      queryFn: async (id, { dispatch }) => {
        try {
          const { data } = await axiosService.delete(`app/view/${id}`);
          return { data };
        } catch (error) {
          dispatch(
            loadingError(
              error.response?.data?.message || error?.message || error
            )
          );
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      invalidatesTags: ["newViews"],
    }),

    getViewById: builder.query({
      queryFn: async (id, { dispatch }) => {
        try {
          const { data } = await axiosService.get(`app/view/${id}`);

          const viewParams = {
            key: data?.data?.id,
            params: data?.data?.jsonFilterCriteria,
          };

          dispatch(newViewActions.setViewParams(viewParams));
          dispatch(newViewActions.setSavedViewParams(viewParams));
          return { data };
        } catch (error) {
          dispatch(
            loadingError(
              error.response?.data?.message || error?.message || error
            )
          );
          return {
            error: error.response?.data?.message || error?.message || error,
          };
        }
      },
      providesTags: ["newViews"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useLazyGetAllViewsQuery,
  useAddViewMutation,
  useUpdateNewViewMutation,
  useDeleteNewViewMutation,
  useLazyGetViewByIdQuery,
} = newListApi;

export default newListApi;
